import type { CRMUser } from '../types';
import { isArchitectRole, isSubcontractorRole } from './userRoles';

/** Same role set suppliers / architects / trades may @mention on comments. */
export const EMPLOYEE_MENTION_DIRECTORY_ROLES = [
  'employee',
  'admin',
  'staff',
  'designer',
  'architect',
  'engineer',
] as const;

export function shouldLoadEmployeeMentionDirectory(role: string | undefined | null): boolean {
  const r = (role || '').trim().toLowerCase();
  return r === 'supplier' || isArchitectRole(r) || isSubcontractorRole(r);
}

export function mapEmployeeMentionDirectoryDocs(
  docs: Array<{ id: string; data: () => Record<string, unknown> }>,
): CRMUser[] {
  return docs.map((userDoc) => {
    const data = userDoc.data();
    const { designerHourlyRate: _omitRate, ...safe } = data;
    return {
      uid: userDoc.id,
      ...safe,
    };
  }) as CRMUser[];
}
